﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";
import Files from "./Files.svelte";
import ThankYou from "./ThankYou.svelte";

const title = projectSettings.classActionName;


const fileUploadPageList = [
	{
		pageIndex: 0,
		component: LandingPage,
		title: "Landing Page",
		showInTracker: false,
		routeId: "/FileUpload",
		nextPage: "FileUpload/Files",
		properties: {
			pageTitle: `${projectSettings.classActionName}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 1,
		component: Files,
		title: "Files",
		showInTracker: true,
		previousPage: "/FileUpload",
		routeId: "/FileUpload/Files",
		nextPage: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Files`,
			persistUrl: "api/file-upload-submit",
			lastVisitedPage: "Files"
		}
	},
	{
		pageIndex: 2,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/Registration/ThankYou",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	},
];

export default fileUploadPageList;
